import { useHandleConversation } from 'iastart/hooks/useHandleConversation'
import { getMessages } from 'iastart/store/slices/conversationSlice'
import { useSelector } from 'react-redux'
import { RootState } from 'core/store'
import { IMessage } from 'core/interfaces/Conversation'
import { ConversationComponent } from 'core/components/conversation/ConversationComponent'
import React from 'react'
import { IApplicationPromptVariable } from 'core/interfaces/Application'

export const ConversationContent: React.FC<{
  application: IApplicationPromptVariable
}> = ({ application }) => {
  const { handleConverse, isLoading, handleResetConversation } =
    useHandleConversation(application.nomTechnique)
  const messages: IMessage[] = useSelector((state: RootState) =>
    getMessages(state, application.nomTechnique)
  )

  return (
    <div className="flex items-center md:w-2/3 w-full mx-auto h-full">
      <ConversationComponent
        application={application}
        messages={messages}
        handleConverse={(msg) => handleConverse(msg)}
        isLoading={isLoading}
        handleResetConversation={handleResetConversation}
      />
    </div>
  )
}
